import React, { useEffect } from "react";
import "./index.scss";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router";
import { trackPageView } from "/src/helpers/analytics";
import LoginPage from "./pages/loginPage";
import HomePage from "./pages/homePage";
import PaymentPage from "./pages/paymentPage";
import PaymentCheckoutPage from "./pages/paymentCheckoutPage";
import DocumentationPage from "./pages/documentationPage";
import ErrataPage from "./pages/errataPage";
import AddCarHirePage from "./pages/addCarHirePage";
import CheckoutPage from "./pages/checkoutPage";
import SiteWrapper from "/src/helpers/Wrappers/siteWrapper.jsx";
import BookingPageWrapper from "/src/helpers/Wrappers/bookingPageWrapper.jsx";

// GA4 page_view on every client-side navigation (the tag's own page view is disabled).
const RouteAnalytics = () => {
  const location = useLocation();
  useEffect(() => { trackPageView(location.pathname + location.search); }, [location.pathname, location.search]);
  return null;
};

// React Router keeps the window's scroll position across navigations, so going from a long page
// (the excursion list, the car results) to a shorter one left the customer part-way down it —
// typically at the footer, having to scroll back up to see their basket. Every route change now
// starts at the top; a #hash link and search-param-only changes (the pages that scroll to their own
// section) are left alone.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (!hash) window.scrollTo(0, 0); }, [pathname, hash]);
  return null;
};

// Mount immediately when the DOM is already parsed — waiting for DOMContentLoaded alone
// races the bundle against the event and can leave the page blank.
function mount() {
  var root = document.getElementById('reactroot');

  createRoot(root).render(
    <BrowserRouter>
      <RouteAnalytics />
      <ScrollToTop />
      <Routes>
        <Route element={<SiteWrapper />} >
          <Route path="login" element={<LoginPage />} />

          <Route element={<BookingPageWrapper />} >
            <Route path="/" element={<HomePage />} />
            <Route path="payment" element={<PaymentPage />} />
            <Route path="payment/checkout" element={<PaymentCheckoutPage />} />
            <Route path="carhire" element={<AddCarHirePage />} />
            <Route path="checkout" element={<CheckoutPage />} />
            <Route path="documentation" element={<DocumentationPage />} />
            <Route path="important-information" element={<ErrataPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}